import i18n from 'i18n';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from 'shared/commonGrid/grid-enums';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { AfFilter, AfFilterGridData } from 'data/afFilter/afFilter.types';

export enum AfFilterMenuActionsType {
  Delete = 'delete',
  View = 'view'
}

export const newAfFilter: AfFilter = {
  id: '',
  fgId: '',
  afId: '',
  owner: '',
  group: '',
  access: '',
};

export const afFilterColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('afFilter.grid.afId'),
    field: 'afName',
    sortable: true,
    resizable: true,
    tooltipField: 'AFNAME',
    flex: 1,
    minWidth: 274,
    maxWidth: 274,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  },
  {
    headerName: i18n.t('afFilter.grid.fgId'),
    field: 'fgName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'FGNAME',
    flex: 1,
    minWidth: 274,
    maxWidth: 274,
  },
];
